import React from "react"
import {FieldTableCellState} from "../../../../../render/table/table-cell";
import formatDate from "../../../../../../gd/format/date";
import {FieldEditableProps} from "../../../../../proto/render/editable";
import {FieldViewSize} from "../../../../../const";
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

// const debug = "FieldStatus_TableCell"
const debug = false


export default class FieldDateRange_Editable extends React.Component<FieldEditableProps, FieldTableCellState> {

    constructor(props:FieldEditableProps) {
        super(props)

        this.state = {
            isHovered       : false,
            showPopover     : false
        }
    }

    get value() {
        return this.props.field.getViewValue(this.props.model)
    }

    get canEdit():boolean {
        return !this.props.disabled && this.props.field.canEdit(this.props.model)
    }

    get classes():string {
        const classes = Classes("ui5-field-editable", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
        return classes
    }

    onMouseEnter = () => {

        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    async onValueChange(value: any|null, hidePopover:boolean=true) {

        // make it first (!) to update model and hidePopover will reRenbder(!)
        this.props.onChange && this.props.onChange(value)

        hidePopover && this.hidePopover()
    }

    onDeleteClick = async (e:React.MouseEvent)=>{
        if (isBulkSelection(e)) return
        e.stopPropagation()
        this.onValueChange(null)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderHovered() {

        const field     = this.props.field
        let value       = this.props.field.getViewValue(this.props.model)
        const classes   = Classes(this.classes, "is-hovered") //w-100-percent h-100-percent

        return (
                <>
                    <div className={classes} onClick={this.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>

                        {!!value && this.renderValue()}
                        { !value && (
                            <div className="w-100-percent flex-row-left-center txt-truncate">
                                {this.props.field.label}
                            </div>
                        )}

                        <div className="buttons flex-no-shrink">
                            {!!value && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                            <div className="btn-arrow"/>
                        </div>

                    </div>

                    {this.state.showPopover &&
                        <field.components.PopoverMenu {...this.props} parent={this}/>
                    }
                </>
        )
    }

    renderValue() {

        let value       = this.props.field.getViewValue(this.props.model)
        const classes   = Classes("w-100-percent", "flex-row-left-center", "txt-truncate")

        return (
            <div className={classes}>
                {!!value && formatDate(value!.start) + " - " + formatDate(value!.end)}
            </div>
        )
    }

    renderNotHovered() {
        return (
            <React.Fragment>
                <div className={this.classes} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    {this.renderValue()}
                </div>
            </React.Fragment>
        )
    }

    render() {
        // debug && console.log(debug, "render()", this.props)
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()
    }
}



